import merge from "lodash/merge";
import { checkWorker } from "../../ActionUtils";
import { LoggerName, getLogger } from "~/modules/logger";
import { ErrorCode, ErrorSeverity } from "~/modules/error";
import { sendWorkerTrackingEvent, toCauseMessage } from "~/modules/telemetry/utils";
import { Action } from "~/modules/actions/Action";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";




export interface SetWorkerAttributesOptions {
    mergeExisting?: boolean;
}
































export class SetWorkerAttributes implements Action<Promise<void>> {
    


    readonly #targetWorkerSid: string;

    


    readonly #attributes: Record<string, any>;

    


    readonly #options?: SetWorkerAttributesOptions;

    constructor(targetWorkerSid: string, attributes: Record<string, any>, options?: SetWorkerAttributesOptions) {
        this.#targetWorkerSid = targetWorkerSid;
        this.#attributes = attributes;
        this.#options = options;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Client);
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        const worker = taskRouter.worker;
        const mergeExisting = this.#options?.mergeExisting ?? false;

        logger.debug(`setWorkerAttributes invoked with targetWorkerSid: ${this.#targetWorkerSid}`);

        checkWorker(worker, {
            actionName: "SetWorkerAttributes",
            moduleName: "actions/Supervisor",
            logger,
            analytics,
            context,
            event: EVENTS.SetWorkerAttributesCompleted,
            extra: {},
            worker
        });

        const newAttributes = mergeExisting ? merge(taskRouter.worker.attributes, this.#attributes) : this.#attributes;

        try {
            await taskRouter.worker.setWorkerAttributes(this.#targetWorkerSid, newAttributes);

            sendWorkerTrackingEvent(EVENTS.SetWorkerAttributesCompleted, analytics, worker, {
                targetWorkerSid: this.#targetWorkerSid,
                mergeExisting
            });

            return Promise.resolve();
        } catch (error) {
            const errorMsg = `SetWorkerAttributes: Failed to set attributes for worker ${
                this.#targetWorkerSid
            } by the supervisor`;
            sendWorkerTrackingEvent(EVENTS.SetWorkerAttributesCompleted, analytics, worker, {
                error: `${errorMsg} (${toCauseMessage(error)})`,
                targetWorkerSid: this.#targetWorkerSid,
                mergeExisting
            });
            return throwFlexSdkError(context)(
                ErrorCode.FailedToSetWorkerAttributesBySupervisor,
                { severity: ErrorSeverity.Error },
                errorMsg,
                error
            );
        }
    }
}
